/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from "formik";
import React from "react";
import { IAddVehicleProps } from "../interfaces/IComplaintLog";
import { Grid, Button, MenuItem, SelectChangeEvent, Box, Autocomplete } from "@mui/material";
import {
    CustomFormLabel,
    CustomSelect,
    CustomTextField,
    CustomTypography,
} from "../../../../../components/formsComponents";
import { batch, useDispatch, useSelector } from "react-redux";
import {
    fetchBrandsAsync,
    fetchCityAsync,
    fetchFaultNameAsync,
    fetchFaultSubTypeAsync,
    fetchFaultTypeAsync,
    fetchModelsAsync,
    fetchStateAsync,
} from "../../../../../redux/common/commonAction";
import { IStoreState } from "../../../../../redux/initialStoreState";
import { useMessagesPopup } from "../../../../../contexts/MessagesPopupProvider/MessagesPopupProvider";
import { useAuth } from "../../../../../contexts/AuthProvider/AuthProvider";
import { api } from "../../../../../api/api";
import { IArea, ICity, IState } from "../../../../../redux/common/types";
import { StandadCard } from "../../../../../components/Cards";

const vehicleType = "FOUR_WHEELER";

export const AddVehicle: React.FC<IAddVehicleProps> = (props) => {
    const { selectedMemberShip, selectedMobileNumber, memberID } =
        props;

    const { showSuccessMessage, showTopErrorSnackbar } = useMessagesPopup();
    const [loading, setLoading] = React.useState(false);

    const auth = useAuth();
    const { state, city, brands, models } = useSelector(
        (storeState: IStoreState) => storeState.common
    );
    const dispatch = useDispatch<any>();

    
    const resetForm = () => {
        setValues({
            membership_code_v: values.membership_code_v,
            vehicle_no_v: "",
            maker_name_v: "",
            model_name_v: "",
            registration_year_v: 0,
            state_v: "",
            city_v: "",
            area_v: "",
            address_v: "",
            gstin_no_v: ""
        });
        setAutoField({
            state: null,
            city: null,
            area: null,
            brand: null,
            model: null,
            // registration_year_v: null
        });
    };

    const { values, errors, handleChange, handleSubmit, setValues } = useFormik({
        initialValues: {
            membership_code_v: memberID,
            vehicle_no_v: "",
            maker_name_v: "",
            model_name_v: "",
            registration_year_v: 0,
            state_v: "",
            city_v: "",
            area_v: "",
            address_v: "",
            gstin_no_v: ""
        },
        validate: (values) => {
            const errors: any = {};
            console.log(memberID);
            if (values.vehicle_no_v === "-1") {
                errors.fault_type_v = "*Vehicle is required";
            } else if (values.maker_name_v === "-1") {
                errors.maker_name_v = "* Brand is required";
            }
            else if (values.model_name_v === "-1") {
                errors.model_name_v = "*Model is required";
            } else if (values.registration_year_v === 0) {
                errors.registration_year_v = "*Year is required";
            } else if (values.state_v === "") {
                errors.state_v = "* location is required";
            } else if (values.area_v === "") {
                errors.area_v = "*Area is required";
            } else if (values.address_v === "") {
                errors.address_v = "*Address is required";
            }
            return errors;
        },
        onSubmit: async (values) => {
            if (auth.user && auth.user.tokens) {
                try {
                    setLoading(true);
                    const res = await api.post(
                        "/prc-add-vehicle-in-family-package",
                        values,
                        {
                            headers: {
                                "auth-Token": auth.user.tokens.access,
                            },
                        }
                    );
                    showSuccessMessage(
                        <>
                            <Box sx={{ width: "100%" }}>
                                New Vehicle Add Successfully!!
                            </Box>
                           
                        </>
                    );
                    setValues({
                        ...values,
                      
                    });
                    resetForm();
                } catch (err: any) {
                    showTopErrorSnackbar(err.response.data.msg);
                } finally {
                    setLoading(false);
                }
            }
        },
    });
    const [autoField, setAutoField] = React.useState<{
        state: IState | null;
        city: ICity | null;
        area: IArea | null;
        brand: string | null;
        model: string | null;
    }>({
        state: null,
        city: null,
        area: null,
        brand: null,
        model: null,
    });

    const handleStateChange = (event: any, newValue: IState | null) => {
        if (newValue) {
            setValues({
                ...values,
                state_v: newValue.state_name,
                city_v: "",
                area_v: "",
            });
            setAutoField({ ...autoField, state: newValue, city: null, area: null });
            dispatch(fetchCityAsync(newValue.state_id));
        }
    };

    const handleCityChange = (event: any, newValue: ICity | null) => {
        if (newValue) {
            setValues({
                ...values,
                city_v: newValue.city_name,
                area_v: "",
            });
            setAutoField({ ...autoField, city: newValue, area: null });
        }
    };

    const handleBrandChange = (event: any, newValue: string | null) => {
        if (newValue) {
            setValues({
                ...values,
                maker_name_v: newValue,
                model_name_v: "",
            });

            setAutoField({ ...autoField, brand: newValue, model: null });
            dispatch(fetchModelsAsync(newValue));
        }
    };

    const handleModelChange = (event: any, newValue: string | null) => {
        if (newValue) {
            setValues({
                ...values,
                model_name_v: newValue,
            });

            setAutoField({ ...autoField, model: newValue });
        }
    };

    const handleYearChange = (event: any, newValue: number | null) => {
        if (newValue) {
            setValues({
                ...values,
                registration_year_v: newValue,
            });

        }
    };
    React.useEffect(() => {
        batch(() => {
          dispatch(fetchStateAsync());
          dispatch(fetchBrandsAsync());
        });
      }, []);


    return (
        <StandadCard >
        <form onSubmit={handleSubmit}>
            <CustomTypography variant="body1">
                You have selected mobile number {memberID}
            </CustomTypography>
            <Grid container spacing={1}>
                <Grid item xs={12} lg={4}>
                    <CustomFormLabel>Membership Code</CustomFormLabel>
                    <CustomTextField
                        id="membership_id_v"
                        variant="outlined"
                        size="small"
                        type="string"
                        disabled
                        fullWidth
                        value={values.membership_code_v}
                        onChange={handleChange}
                        error={errors.membership_code_v ? true : false}
                        helperText={errors.membership_code_v}
                    />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <CustomFormLabel>Vechicle Number</CustomFormLabel>
                    <CustomTextField
                        id="vehicle_no_v"
                        variant="outlined"
                        size="small"
                        type="string"
                        fullWidth
                        value={values.vehicle_no_v}
                        onChange={handleChange}
                        error={errors.vehicle_no_v ? true : false}
                        helperText={errors.vehicle_no_v}
                    />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <CustomFormLabel>Registration Year</CustomFormLabel>
                    <CustomTextField
                        id="registration_year_v"
                        variant="outlined"
                        size="small"
                        type="number"
                        fullWidth
                        value={values.registration_year_v}
                        onChange={handleChange}
                        error={errors.registration_year_v ? true : false}
                        helperText={errors.registration_year_v}
                    />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <CustomFormLabel>Brand</CustomFormLabel>
                    <Autocomplete
                        disablePortal
                        value={autoField.brand}
                        options={brands.list}
                        getOptionLabel={(item) => item}
                        onChange={handleBrandChange}
                        renderInput={(params) => (
                            <CustomTextField
                                {...params}
                                error={errors.maker_name_v ? true : false}
                                helperText={errors.maker_name_v}
                                label="Select Brand"
                                size="small"
                                variant="outlined"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <CustomFormLabel>Model</CustomFormLabel>
                    <Autocomplete
                        disablePortal
                        value={autoField.model}
                        options={
                            autoField.brand
                                ? models.list[autoField.brand] || []
                                : []
                        }
                        getOptionLabel={(item) => item}
                        onChange={handleModelChange}
                        renderInput={(params) => (
                            <CustomTextField
                                {...params}
                                error={errors.model_name_v ? true : false}
                                helperText={errors.model_name_v}
                                label="Select Model"
                                size="small"
                                variant="outlined"
                            />
                        )}
                    />
                </Grid>
              
               
                <Grid item xs={12} lg={4}>
                    <CustomFormLabel>State</CustomFormLabel>
                    <Autocomplete
                        disablePortal
                        value={autoField.state}
                        options={state.list}
                        getOptionLabel={(item) => item.state_name}
                        onChange={handleStateChange}
                        renderInput={(params) => (
                            <CustomTextField
                                {...params}
                                error={errors.state_v ? true : false}
                                helperText={errors.state_v}
                                label="Select State"
                                size="small"
                                variant="outlined"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <CustomFormLabel>City</CustomFormLabel>
                    <Autocomplete
                        disablePortal
                        value={autoField.city}
                        options={
                            autoField.state
                                ? city.list[autoField.state.state_id] || []
                                : []
                        }
                        getOptionLabel={(item) => item.city_name}
                        onChange={handleCityChange}
                        renderInput={(params) => (
                            <CustomTextField
                                {...params}
                                error={errors.city_v ? true : false}
                                helperText={errors.city_v}
                                label="Select City"
                                size="small"
                                variant="outlined"
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <CustomFormLabel>Area</CustomFormLabel>
                    <CustomTextField
                        id="area_v"
                        variant="outlined"
                        size="small"
                        type="string"
                        fullWidth
                        value={values.area_v}
                        onChange={handleChange}
                        error={errors.area_v ? true : false}
                        helperText={errors.area_v}
                    />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <CustomFormLabel>GST No</CustomFormLabel>
                    <CustomTextField
                        id="gstin_no_v"
                        variant="outlined"
                        size="small"
                        type="string"
                        fullWidth
                        value={values.gstin_no_v}
                        onChange={handleChange}
                        error={errors.gstin_no_v ? true : false}
                        helperText={errors.gstin_no_v}
                    />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <CustomFormLabel>Address</CustomFormLabel>
                    <CustomTextField
                        id="address_v"
                        variant="outlined"
                        size="small"
                        type="string"
                        fullWidth
                        multiline
                        rows={2}
                        value={values.address_v}
                        onChange={handleChange}
                        error={errors.address_v ? true : false}
                        helperText={errors.address_v}
                    />
                </Grid>
                <Grid item xs={12} lg={3} />
                <Grid item xs={12} lg={3} />
                <Grid item xs={12} lg={3} />
                <Grid item xs={12} lg={3}>
                    <Button
                        fullWidth
                        disabled={loading}
                        variant="contained"
                        type="submit"
                    >
                        Submit
                    </Button>
                </Grid>
            </Grid>
        </form>
        </StandadCard>
    );
};


